import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { Typography } from '../../base';

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: 'fit-content',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  containerHorizontal: {
    display: 'flex',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
    },
  },
  label: {
    maxWidth: 70,
    order: 2,
    textAlign: 'center',

    '&.notRelevant': {
      color: theme.palette.text.secondary,
    },

    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(),
      marginRight: theme.spacing(2),
      textAlign: 'left',
    },
  },
  stepIcon: {
    order: 1,
  },
  stepEmpty: {
    border: `1px solid ${theme.palette.text.secondary}`,
    borderRadius: '50%',
    height: 20,
    width: 20,
    minWidth: 20,
  },
  stepNotImportantContainer: {
    position: 'relative',
  },
  stepNotImportantStrikethroughLine: {
    height: 19,
    width: 18,
    minWidth: 18,
    position: 'absolute',
    borderBottom: `1px solid ${theme.palette.text.secondary}`,
    transform: 'rotate(-45deg)',
    top: -6,
    right: 7,
  },
  stepDone: {
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: '50%',
    background: theme.palette.secondary.main,
    height: 20,
    width: 20,
    minWidth: 20,
  },
  stepInProgressContainer: {
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: '50%',
    height: 20,
    width: 20,
    minWidth: 20,
    overflow: 'hidden',
  },
  stepInProgressLeft: {
    display: 'inline-block',
    background: theme.palette.secondary.main,
    height: 20,
    width: 10,
  },
  stepInProgressRight: {
    display: 'inline-block',
    height: 20,
    width: 10,
  }
})

class Step extends Component {
  renderEmptyCircle = c => <div className={c.stepEmpty} />

  renderStrikethroughCircle = c => {
    return (
      <div className={c.stepNotImportantContainer}>
        <div className={c.stepEmpty} />
        <div className={c.stepNotImportantStrikethroughLine} />
      </div>
    );
  }

  renderFullCircle = c => <div className={c.stepDone} />

  renderHalfCircle = c => {
    return (
      <div className={c.stepInProgressContainer} >
        <div className={c.stepInProgressLeft} />
        <div className={c.stepInProgressRight} />
      </div>
    );
  }

  getProgressIcon = (stepProgress, c) => {
    switch (stepProgress) {
      case 'COMPLETED':
      case 'FULFILLED':
      case true:
        return this.renderFullCircle(c);
      case 'NOT_RELEVANT':
      case 'NOT_APPLICABLE':
        return this.renderStrikethroughCircle(c);
      case 'STARTED':
      case 'HALF_FULFILLED':
        return this.renderHalfCircle(c);
      case 'NOT_STARTED':
      case 'UNFULFILLED':
      case false:
      case null:
      default:
        return this.renderEmptyCircle(c);
    }
  }

  render() {
    const { step, horizontal, classes: c } = this.props;
    const isNotRelevant = status => status === 'NOT_RELEVANT' || status === 'NOT_APPLICABLE';

    return (
      <div className={classNames(horizontal ? c.containerHorizontal : c.container, 'stepContainer')} >
        <span className={classNames(c.stepIcon, 'stepIcon')}>{this.getProgressIcon(step.status, c)}</span>
        <Typography
          variant="body2"
          className={classNames(c.label, 'stepLabel', isNotRelevant(step.status) ? 'notRelevant' : '')}
        >
          {step.label}
        </Typography>
      </div>
    );
  }
}

Step.propTypes = {
  horizontal: PropTypes.bool,
}

export default withStyles(styles)(Step);



// WEBPACK FOOTER //
// ./src/components/base/Step/Step.js